import { Box } from 'src/components/UI/Box';
import { PrescriptionPreview } from './components/PrescriptionPreview';
import { StepHeader } from './components/StepHeader';
import { NavigationButtons } from './components/NavigationButtons';
import { type PlaceOfServiceValues } from './types';

interface PreviewStepProps {
  data: PlaceOfServiceValues;
  logoPreview: string | null;
  onNext: () => void;
  onBack: () => void;
}

export function PreviewStep({ data, logoPreview, onNext, onBack }: PreviewStepProps) {
  return (
    <Box h="100%" display="flex" flexDir="column">
      <StepHeader title="Confira como ficou!" subtitle="Veja como seu paciente receberá sua receita na Mevo." />

      <Box flex="1" minH="0" overflowY="auto" display="flex" justifyContent="center" alignItems="center" py="16px">
        <Box w="100%" maxW={{ base: '90%', sm: '400px' }} px={{ base: '0', sm: '20px' }}>
          <PrescriptionPreview data={data} logoPreview={logoPreview} isMobileStep />
        </Box>
      </Box>

      <NavigationButtons onBack={onBack} onNext={onNext} />
    </Box>
  );
}
